import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import css from './index.module.scss';
import { wintextObj } from './wintext';
import IconTips from './Icons/IconTips';
import { baseUrl } from '@/service/util';
import request from '@/utils/request';

export const dpuCoupon = ({ email = '', couponOrderNumber = '' }, locale?: string) => {
    return request.get(`${baseUrl(locale)}/dpuCoupon?locale=${locale}`, {
        needToken: true,
        params: {
            email,
            couponOrderNumber,
        },
    });
};

export default function VoucherWin({ callback }: any) {
    const [stepVal, setStepVal] = useState('a1');
    const { locale, pathname } = useRouter();
    const [errorB, setErrorB] = useState(false); //验证错误
    const [valA, setValA] = useState(''); //第1个值
    const [valB, setValB] = useState(''); //第2个值
    const [resDataA, setResDataA] = useState('');
    const [failTips, setFailTips] = useState('');
    const [copySuccess, setCopySuccess] = useState(false);
    const wintext = wintextObj[locale as any] || wintextObj['us'];
    const [isClient, setIsClient] = useState<boolean>(false);
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';

    // 值输入
    const changeHandleA = (e: any) => {
        const val = e.target.value;
        setValA(val);
    };
    // 值输入
    const changeHandleB = (e: any) => {
        const val = e.target.value;
        setValB(val);
    };
    // 提交
    const submitHandle = async () => {
        const emailRegex = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
        if (valA && valB) {
            if (!emailRegex.test(valB)) {
                return setErrorB(true);
            } else {
                setErrorB(false);
            }
            const res = await dpuCoupon(
                {
                    email: `${valB}`.trim(),
                    couponOrderNumber: `${valA}`.trim(),
                },
                locale,
            );
            if (res.code === '0' && res.data) {
                setResDataA(res.data);
                setStepVal('a2');
            } else if (res.code === '0') {
                setFailTips(wintext.win_fail_tips);
            } else {
                setFailTips(res.message);
            }
        }
    };
    // 关闭
    const closeHandle = () => {
        callback && callback('close');
    };

    useEffect(() => {
        setIsClient(true);
    }, []);
    // 复制
    const copyHandle = async () => {
        try {
            navigator.clipboard.writeText(resDataA);
            setCopySuccess(true);
        } catch (err: any) {}
    };
    if (isClient) {
        return ReactDOM.createPortal(
            <div className={`${css.VoucherWin} theme-${theme}`}>
                <div className="win-container win-container-voucher">
                    <span className="win-close" onClick={closeHandle}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="system/line/cancel">
                                <path
                                    id="Combined-Shape"
                                    d="M6 5L19 18M19 5L6 18"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </g>
                        </svg>
                    </span>
                    {stepVal === 'a1' && (
                        <>
                            <div className="win-mainer win-form">
                                <div className="win-title">{wintext.win_title}</div>
                                <div className="win-form-item win-form-item-a">
                                    <input className="win-form-input" value={valA} onChange={changeHandleA} placeholder={wintext.win_placeholder1} />
                                    <div className="win-form-tips">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path
                                                d="M10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18Z"
                                                stroke="#949494"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.5752 8.00047C7.77112 7.44353 8.15782 6.9739 8.66682 6.67475C9.17583 6.37561 9.77427 6.26626 10.3562 6.36607C10.9381 6.46588 11.4659 6.76841 11.8461 7.22008C12.2263 7.67175 12.4344 8.24341 12.4335 8.83381C12.4335 10.5005 9.93353 11.3338 9.93353 11.3338V12.5838"
                                                stroke="#949494"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path d="M10 14.667H10.0083" stroke="#949494" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <div className="win-tips-box">
                                            <div className="win-tips-linea">{wintext.win_tipa1}</div>
                                            <div className="win-tips-lineb win-tips-lineb1">{locale === 'ca' ? wintext.win_tipa2_ca : wintext.win_tipa2}</div>
                                            <div className="win-tips-linea">{wintext.win_tipb1}</div>
                                            <div className="win-tips-lineb win-tips-lineb2 11">{wintext.win_tipb2}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`win-form-item${errorB ? ' win-form-error-show' : ''}`}>
                                    <input className="win-form-input" value={valB} onChange={changeHandleB} placeholder={wintext.win_placeholder2} />
                                </div>
                                <div className={`win-form-error${errorB ? ' win-form-error-show' : ''}`}>
                                    <IconTips />
                                    <span>{wintext.win_error_email}</span>
                                </div>
                                {failTips && <div className="win-form-error win-form-error-show">{failTips}</div>}
                                <button className={`win-submit${valA && valB ? '' : ' win-submit-disabled'}`} onClick={submitHandle}>
                                    {wintext.win_submit}
                                </button>
                            </div>
                        </>
                    )}
                    {stepVal === 'a2' && (
                        <>
                            <div className="win-mainer">
                                <div className="win-title win-title-code">{wintext.win2_title}</div>
                                <div className="win-code">{resDataA}</div>
                                <div className={`win-code-btn ${copySuccess ? ' win-code-btn-success' : ''}`} onClick={copyHandle}>
                                    <span className="win-code-btn-ms1">Copy Code</span>
                                    <span className="win-code-btn-ms2">Copy Success</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>,
            (document as any).body,
        );
    }
    return <></>;
}
